/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type LambdaResp = {
  __typename: "LambdaResp",
  statusCode?: number | null,
  body?: string | null,
};

export type Ec2ResourceReq = {
  type: string,
  region: string,
};

export type CreateAccountQuotaInput = {
  accountId: string,
  scanQuota: number,
};

export type ModelAccountQuotaConditionInput = {
  scanQuota?: ModelIntInput | null,
  and?: Array< ModelAccountQuotaConditionInput | null > | null,
  or?: Array< ModelAccountQuotaConditionInput | null > | null,
  not?: ModelAccountQuotaConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type AccountQuota = {
  __typename: "AccountQuota",
  accountId: string,
  scanQuota: number,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateAccountQuotaInput = {
  accountId: string,
  scanQuota?: number | null,
};

export type DeleteAccountQuotaInput = {
  accountId: string,
};

export type CreateAccountPaymentsInput = {
  accountId: string,
  orderId: string,
  productId: string,
  status: string,
};

export type ModelAccountPaymentsConditionInput = {
  productId?: ModelStringInput | null,
  status?: ModelStringInput | null,
  and?: Array< ModelAccountPaymentsConditionInput | null > | null,
  or?: Array< ModelAccountPaymentsConditionInput | null > | null,
  not?: ModelAccountPaymentsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type AccountPayments = {
  __typename: "AccountPayments",
  accountId: string,
  orderId: string,
  productId: string,
  status: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateAccountPaymentsInput = {
  accountId: string,
  orderId: string,
  productId?: string | null,
  status?: string | null,
};

export type DeleteAccountPaymentsInput = {
  accountId: string,
  orderId: string,
};

export type CreateEc2PriceInput = {
  instanceType: string,
  region: string,
  price: string,
  location?: string | null,
  instanceFamily?: string | null,
  vCPU?: string | null,
  memory?: string | null,
  storage?: string | null,
  networkPerformance?: string | null,
  operatingSystem?: string | null,
};

export type ModelEc2PriceConditionInput = {
  price?: ModelStringInput | null,
  location?: ModelStringInput | null,
  instanceFamily?: ModelStringInput | null,
  vCPU?: ModelStringInput | null,
  memory?: ModelStringInput | null,
  storage?: ModelStringInput | null,
  networkPerformance?: ModelStringInput | null,
  operatingSystem?: ModelStringInput | null,
  and?: Array< ModelEc2PriceConditionInput | null > | null,
  or?: Array< ModelEc2PriceConditionInput | null > | null,
  not?: ModelEc2PriceConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Ec2Price = {
  __typename: "Ec2Price",
  instanceType: string,
  region: string,
  price: string,
  location?: string | null,
  instanceFamily?: string | null,
  vCPU?: string | null,
  memory?: string | null,
  storage?: string | null,
  networkPerformance?: string | null,
  operatingSystem?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateEc2PriceInput = {
  instanceType: string,
  region: string,
  price?: string | null,
  location?: string | null,
  instanceFamily?: string | null,
  vCPU?: string | null,
  memory?: string | null,
  storage?: string | null,
  networkPerformance?: string | null,
  operatingSystem?: string | null,
};

export type DeleteEc2PriceInput = {
  instanceType: string,
  region: string,
};

export type CreateUserInfoInput = {
  userId: string,
  userName?: string | null,
};

export type ModelUserInfoConditionInput = {
  userName?: ModelStringInput | null,
  and?: Array< ModelUserInfoConditionInput | null > | null,
  or?: Array< ModelUserInfoConditionInput | null > | null,
  not?: ModelUserInfoConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type UserInfo = {
  __typename: "UserInfo",
  userId: string,
  accounts?: ModelAccountInfoConnection | null,
  userName?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type ModelAccountInfoConnection = {
  __typename: "ModelAccountInfoConnection",
  items:  Array<AccountInfo | null >,
  nextToken?: string | null,
};

export type AccountInfo = {
  __typename: "AccountInfo",
  accountId: string,
  monitorRoleArn: string,
  accountName?: string | null,
  refreshRule?: string | null,
  createdAt: string,
  updatedAt: string,
  userInfoAccountsUserId?: string | null,
  owner?: string | null,
};

export type UpdateUserInfoInput = {
  userId: string,
  userName?: string | null,
};

export type DeleteUserInfoInput = {
  userId: string,
};

export type CreateAccountInfoInput = {
  accountId: string,
  monitorRoleArn: string,
  accountName?: string | null,
  refreshRule?: string | null,
  userInfoAccountsUserId?: string | null,
};

export type ModelAccountInfoConditionInput = {
  monitorRoleArn?: ModelStringInput | null,
  accountName?: ModelStringInput | null,
  refreshRule?: ModelStringInput | null,
  and?: Array< ModelAccountInfoConditionInput | null > | null,
  or?: Array< ModelAccountInfoConditionInput | null > | null,
  not?: ModelAccountInfoConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  userInfoAccountsUserId?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type UpdateAccountInfoInput = {
  accountId: string,
  monitorRoleArn?: string | null,
  accountName?: string | null,
  refreshRule?: string | null,
  userInfoAccountsUserId?: string | null,
};

export type DeleteAccountInfoInput = {
  accountId: string,
};

export type CreateAccountToResourceInput = {
  accountId: string,
  resourceId: string,
  resourceRegion: string,
  resourceStatus: ResourceStatus,
  resourceType?: string | null,
  resourceCreatedAt?: string | null,
  resourcePriceType?: string | null,
  tags?: string | null,
  index?: number | null,
  summary?: SummaryInput | null,
};

export enum ResourceStatus {
  LOADING = "LOADING",
  NODATA = "NODATA",
  IDLE = "IDLE",
  NORMAL = "NORMAL",
  BUSY = "BUSY",
}


export type SummaryInput = {
  resourceType?: string | null,
  status?: ScanStatus | null,
  scannedCount?: number | null,
  idleCount?: number | null,
};

export enum ScanStatus {
  NONE = "NONE",
  INPROGRESS = "INPROGRESS",
  DONE = "DONE",
}


export type ModelAccountToResourceConditionInput = {
  resourceRegion?: ModelStringInput | null,
  resourceStatus?: ModelResourceStatusInput | null,
  resourceType?: ModelStringInput | null,
  resourceCreatedAt?: ModelStringInput | null,
  resourcePriceType?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  index?: ModelIntInput | null,
  and?: Array< ModelAccountToResourceConditionInput | null > | null,
  or?: Array< ModelAccountToResourceConditionInput | null > | null,
  not?: ModelAccountToResourceConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type ModelResourceStatusInput = {
  eq?: ResourceStatus | null,
  ne?: ResourceStatus | null,
};

export type AccountToResource = {
  __typename: "AccountToResource",
  accountId: string,
  resourceId: string,
  resourceRegion: string,
  resourceStatus: ResourceStatus,
  resourceType?: string | null,
  resourceCreatedAt?: string | null,
  resourcePriceType?: string | null,
  tags?: string | null,
  index?: number | null,
  summary?: Summary | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type Summary = {
  __typename: "Summary",
  resourceType?: string | null,
  status?: ScanStatus | null,
  scannedCount?: number | null,
  idleCount?: number | null,
};

export type UpdateAccountToResourceInput = {
  accountId: string,
  resourceId: string,
  resourceRegion?: string | null,
  resourceStatus?: ResourceStatus | null,
  resourceType?: string | null,
  resourceCreatedAt?: string | null,
  resourcePriceType?: string | null,
  tags?: string | null,
  index?: number | null,
  summary?: SummaryInput | null,
};

export type DeleteAccountToResourceInput = {
  accountId: string,
  resourceId: string,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelEc2PriceFilterInput = {
  instanceType?: ModelStringInput | null,
  region?: ModelStringInput | null,
  price?: ModelStringInput | null,
  location?: ModelStringInput | null,
  instanceFamily?: ModelStringInput | null,
  vCPU?: ModelStringInput | null,
  memory?: ModelStringInput | null,
  storage?: ModelStringInput | null,
  networkPerformance?: ModelStringInput | null,
  operatingSystem?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEc2PriceFilterInput | null > | null,
  or?: Array< ModelEc2PriceFilterInput | null > | null,
  not?: ModelEc2PriceFilterInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelEc2PriceConnection = {
  __typename: "ModelEc2PriceConnection",
  items:  Array<Ec2Price | null >,
  nextToken?: string | null,
};

export type ModelUserInfoFilterInput = {
  userId?: ModelStringInput | null,
  userName?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserInfoFilterInput | null > | null,
  or?: Array< ModelUserInfoFilterInput | null > | null,
  not?: ModelUserInfoFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelUserInfoConnection = {
  __typename: "ModelUserInfoConnection",
  items:  Array<UserInfo | null >,
  nextToken?: string | null,
};

export type ModelAccountInfoFilterInput = {
  accountId?: ModelStringInput | null,
  monitorRoleArn?: ModelStringInput | null,
  accountName?: ModelStringInput | null,
  refreshRule?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAccountInfoFilterInput | null > | null,
  or?: Array< ModelAccountInfoFilterInput | null > | null,
  not?: ModelAccountInfoFilterInput | null,
  userInfoAccountsUserId?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type ModelAccountQuotaFilterInput = {
  accountId?: ModelStringInput | null,
  scanQuota?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAccountQuotaFilterInput | null > | null,
  or?: Array< ModelAccountQuotaFilterInput | null > | null,
  not?: ModelAccountQuotaFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelAccountQuotaConnection = {
  __typename: "ModelAccountQuotaConnection",
  items:  Array<AccountQuota | null >,
  nextToken?: string | null,
};

export type ModelAccountPaymentsFilterInput = {
  accountId?: ModelStringInput | null,
  orderId?: ModelStringInput | null,
  productId?: ModelStringInput | null,
  status?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAccountPaymentsFilterInput | null > | null,
  or?: Array< ModelAccountPaymentsFilterInput | null > | null,
  not?: ModelAccountPaymentsFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelAccountPaymentsConnection = {
  __typename: "ModelAccountPaymentsConnection",
  items:  Array<AccountPayments | null >,
  nextToken?: string | null,
};

export type ModelAccountToResourceFilterInput = {
  accountId?: ModelStringInput | null,
  resourceId?: ModelStringInput | null,
  resourceRegion?: ModelStringInput | null,
  resourceStatus?: ModelResourceStatusInput | null,
  resourceType?: ModelStringInput | null,
  resourceCreatedAt?: ModelStringInput | null,
  resourcePriceType?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  index?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAccountToResourceFilterInput | null > | null,
  or?: Array< ModelAccountToResourceFilterInput | null > | null,
  not?: ModelAccountToResourceFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelAccountToResourceConnection = {
  __typename: "ModelAccountToResourceConnection",
  items:  Array<AccountToResource | null >,
  nextToken?: string | null,
};

export type ModelSubscriptionEc2PriceFilterInput = {
  instanceType?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionStringInput | null,
  location?: ModelSubscriptionStringInput | null,
  instanceFamily?: ModelSubscriptionStringInput | null,
  vCPU?: ModelSubscriptionStringInput | null,
  memory?: ModelSubscriptionStringInput | null,
  storage?: ModelSubscriptionStringInput | null,
  networkPerformance?: ModelSubscriptionStringInput | null,
  operatingSystem?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEc2PriceFilterInput | null > | null,
  or?: Array< ModelSubscriptionEc2PriceFilterInput | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionUserInfoFilterInput = {
  userId?: ModelSubscriptionStringInput | null,
  userName?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserInfoFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserInfoFilterInput | null > | null,
  userInfoAccountsUserId?: ModelSubscriptionStringInput | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionAccountInfoFilterInput = {
  accountId?: ModelSubscriptionStringInput | null,
  monitorRoleArn?: ModelSubscriptionStringInput | null,
  accountName?: ModelSubscriptionStringInput | null,
  refreshRule?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAccountInfoFilterInput | null > | null,
  or?: Array< ModelSubscriptionAccountInfoFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionAccountQuotaFilterInput = {
  accountId?: ModelSubscriptionStringInput | null,
  scanQuota?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAccountQuotaFilterInput | null > | null,
  or?: Array< ModelSubscriptionAccountQuotaFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionAccountPaymentsFilterInput = {
  accountId?: ModelSubscriptionStringInput | null,
  orderId?: ModelSubscriptionStringInput | null,
  productId?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAccountPaymentsFilterInput | null > | null,
  or?: Array< ModelSubscriptionAccountPaymentsFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionAccountToResourceFilterInput = {
  accountId?: ModelSubscriptionStringInput | null,
  resourceId?: ModelSubscriptionStringInput | null,
  resourceRegion?: ModelSubscriptionStringInput | null,
  resourceStatus?: ModelSubscriptionStringInput | null,
  resourceType?: ModelSubscriptionStringInput | null,
  resourceCreatedAt?: ModelSubscriptionStringInput | null,
  resourcePriceType?: ModelSubscriptionStringInput | null,
  tags?: ModelSubscriptionStringInput | null,
  index?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAccountToResourceFilterInput | null > | null,
  or?: Array< ModelSubscriptionAccountToResourceFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type InitScanMutationVariables = {
  accountId: string,
  resources?: string | null,
};

export type InitScanMutation = {
  initScan?:  {
    __typename: "LambdaResp",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type DoScanMutationVariables = {
  accountId: string,
  resourceId: string,
};

export type DoScanMutation = {
  doScan?:  {
    __typename: "LambdaResp",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type UpdatePricingMutationVariables = {
  accountId: string,
  resourceId: string,
};

export type UpdatePricingMutation = {
  updatePricing?:  {
    __typename: "LambdaResp",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type BatchGetEc2PricesMutationVariables = {
  resources: Array< Ec2ResourceReq | null >,
};

export type BatchGetEc2PricesMutation = {
  batchGetEc2Prices?:  {
    __typename: "LambdaResp",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type CheckoutMutationVariables = {
  accountId: string,
  productId: string,
};

export type CheckoutMutation = {
  checkout?:  {
    __typename: "LambdaResp",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type ValidatePaymentMutationVariables = {
  accountId: string,
  sessionId: string,
};

export type ValidatePaymentMutation = {
  validatePayment?:  {
    __typename: "LambdaResp",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type FreeQuotaMutationVariables = {
  accountId: string,
};

export type FreeQuotaMutation = {
  freeQuota?:  {
    __typename: "LambdaResp",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type CreateAccountQuotaMutationVariables = {
  input: CreateAccountQuotaInput,
  condition?: ModelAccountQuotaConditionInput | null,
};

export type CreateAccountQuotaMutation = {
  createAccountQuota?:  {
    __typename: "AccountQuota",
    accountId: string,
    scanQuota: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateAccountQuotaMutationVariables = {
  input: UpdateAccountQuotaInput,
  condition?: ModelAccountQuotaConditionInput | null,
};

export type UpdateAccountQuotaMutation = {
  updateAccountQuota?:  {
    __typename: "AccountQuota",
    accountId: string,
    scanQuota: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteAccountQuotaMutationVariables = {
  input: DeleteAccountQuotaInput,
  condition?: ModelAccountQuotaConditionInput | null,
};

export type DeleteAccountQuotaMutation = {
  deleteAccountQuota?:  {
    __typename: "AccountQuota",
    accountId: string,
    scanQuota: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateAccountPaymentsMutationVariables = {
  input: CreateAccountPaymentsInput,
  condition?: ModelAccountPaymentsConditionInput | null,
};

export type CreateAccountPaymentsMutation = {
  createAccountPayments?:  {
    __typename: "AccountPayments",
    accountId: string,
    orderId: string,
    productId: string,
    status: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateAccountPaymentsMutationVariables = {
  input: UpdateAccountPaymentsInput,
  condition?: ModelAccountPaymentsConditionInput | null,
};

export type UpdateAccountPaymentsMutation = {
  updateAccountPayments?:  {
    __typename: "AccountPayments",
    accountId: string,
    orderId: string,
    productId: string,
    status: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteAccountPaymentsMutationVariables = {
  input: DeleteAccountPaymentsInput,
  condition?: ModelAccountPaymentsConditionInput | null,
};

export type DeleteAccountPaymentsMutation = {
  deleteAccountPayments?:  {
    __typename: "AccountPayments",
    accountId: string,
    orderId: string,
    productId: string,
    status: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateEc2PriceMutationVariables = {
  input: CreateEc2PriceInput,
  condition?: ModelEc2PriceConditionInput | null,
};

export type CreateEc2PriceMutation = {
  createEc2Price?:  {
    __typename: "Ec2Price",
    instanceType: string,
    region: string,
    price: string,
    location?: string | null,
    instanceFamily?: string | null,
    vCPU?: string | null,
    memory?: string | null,
    storage?: string | null,
    networkPerformance?: string | null,
    operatingSystem?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEc2PriceMutationVariables = {
  input: UpdateEc2PriceInput,
  condition?: ModelEc2PriceConditionInput | null,
};

export type UpdateEc2PriceMutation = {
  updateEc2Price?:  {
    __typename: "Ec2Price",
    instanceType: string,
    region: string,
    price: string,
    location?: string | null,
    instanceFamily?: string | null,
    vCPU?: string | null,
    memory?: string | null,
    storage?: string | null,
    networkPerformance?: string | null,
    operatingSystem?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEc2PriceMutationVariables = {
  input: DeleteEc2PriceInput,
  condition?: ModelEc2PriceConditionInput | null,
};

export type DeleteEc2PriceMutation = {
  deleteEc2Price?:  {
    __typename: "Ec2Price",
    instanceType: string,
    region: string,
    price: string,
    location?: string | null,
    instanceFamily?: string | null,
    vCPU?: string | null,
    memory?: string | null,
    storage?: string | null,
    networkPerformance?: string | null,
    operatingSystem?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserInfoMutationVariables = {
  input: CreateUserInfoInput,
  condition?: ModelUserInfoConditionInput | null,
};

export type CreateUserInfoMutation = {
  createUserInfo?:  {
    __typename: "UserInfo",
    userId: string,
    accounts?:  {
      __typename: "ModelAccountInfoConnection",
      items:  Array< {
        __typename: "AccountInfo",
        accountId: string,
        monitorRoleArn: string,
        accountName?: string | null,
        refreshRule?: string | null,
        createdAt: string,
        updatedAt: string,
        userInfoAccountsUserId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userName?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateUserInfoMutationVariables = {
  input: UpdateUserInfoInput,
  condition?: ModelUserInfoConditionInput | null,
};

export type UpdateUserInfoMutation = {
  updateUserInfo?:  {
    __typename: "UserInfo",
    userId: string,
    accounts?:  {
      __typename: "ModelAccountInfoConnection",
      items:  Array< {
        __typename: "AccountInfo",
        accountId: string,
        monitorRoleArn: string,
        accountName?: string | null,
        refreshRule?: string | null,
        createdAt: string,
        updatedAt: string,
        userInfoAccountsUserId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userName?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteUserInfoMutationVariables = {
  input: DeleteUserInfoInput,
  condition?: ModelUserInfoConditionInput | null,
};

export type DeleteUserInfoMutation = {
  deleteUserInfo?:  {
    __typename: "UserInfo",
    userId: string,
    accounts?:  {
      __typename: "ModelAccountInfoConnection",
      items:  Array< {
        __typename: "AccountInfo",
        accountId: string,
        monitorRoleArn: string,
        accountName?: string | null,
        refreshRule?: string | null,
        createdAt: string,
        updatedAt: string,
        userInfoAccountsUserId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userName?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateAccountInfoMutationVariables = {
  input: CreateAccountInfoInput,
  condition?: ModelAccountInfoConditionInput | null,
};

export type CreateAccountInfoMutation = {
  createAccountInfo?:  {
    __typename: "AccountInfo",
    accountId: string,
    monitorRoleArn: string,
    accountName?: string | null,
    refreshRule?: string | null,
    createdAt: string,
    updatedAt: string,
    userInfoAccountsUserId?: string | null,
    owner?: string | null,
  } | null,
};

export type UpdateAccountInfoMutationVariables = {
  input: UpdateAccountInfoInput,
  condition?: ModelAccountInfoConditionInput | null,
};

export type UpdateAccountInfoMutation = {
  updateAccountInfo?:  {
    __typename: "AccountInfo",
    accountId: string,
    monitorRoleArn: string,
    accountName?: string | null,
    refreshRule?: string | null,
    createdAt: string,
    updatedAt: string,
    userInfoAccountsUserId?: string | null,
    owner?: string | null,
  } | null,
};

export type DeleteAccountInfoMutationVariables = {
  input: DeleteAccountInfoInput,
  condition?: ModelAccountInfoConditionInput | null,
};

export type DeleteAccountInfoMutation = {
  deleteAccountInfo?:  {
    __typename: "AccountInfo",
    accountId: string,
    monitorRoleArn: string,
    accountName?: string | null,
    refreshRule?: string | null,
    createdAt: string,
    updatedAt: string,
    userInfoAccountsUserId?: string | null,
    owner?: string | null,
  } | null,
};

export type CreateAccountToResourceMutationVariables = {
  input: CreateAccountToResourceInput,
  condition?: ModelAccountToResourceConditionInput | null,
};

export type CreateAccountToResourceMutation = {
  createAccountToResource?:  {
    __typename: "AccountToResource",
    accountId: string,
    resourceId: string,
    resourceRegion: string,
    resourceStatus: ResourceStatus,
    resourceType?: string | null,
    resourceCreatedAt?: string | null,
    resourcePriceType?: string | null,
    tags?: string | null,
    index?: number | null,
    summary?:  {
      __typename: "Summary",
      resourceType?: string | null,
      status?: ScanStatus | null,
      scannedCount?: number | null,
      idleCount?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateAccountToResourceMutationVariables = {
  input: UpdateAccountToResourceInput,
  condition?: ModelAccountToResourceConditionInput | null,
};

export type UpdateAccountToResourceMutation = {
  updateAccountToResource?:  {
    __typename: "AccountToResource",
    accountId: string,
    resourceId: string,
    resourceRegion: string,
    resourceStatus: ResourceStatus,
    resourceType?: string | null,
    resourceCreatedAt?: string | null,
    resourcePriceType?: string | null,
    tags?: string | null,
    index?: number | null,
    summary?:  {
      __typename: "Summary",
      resourceType?: string | null,
      status?: ScanStatus | null,
      scannedCount?: number | null,
      idleCount?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteAccountToResourceMutationVariables = {
  input: DeleteAccountToResourceInput,
  condition?: ModelAccountToResourceConditionInput | null,
};

export type DeleteAccountToResourceMutation = {
  deleteAccountToResource?:  {
    __typename: "AccountToResource",
    accountId: string,
    resourceId: string,
    resourceRegion: string,
    resourceStatus: ResourceStatus,
    resourceType?: string | null,
    resourceCreatedAt?: string | null,
    resourcePriceType?: string | null,
    tags?: string | null,
    index?: number | null,
    summary?:  {
      __typename: "Summary",
      resourceType?: string | null,
      status?: ScanStatus | null,
      scannedCount?: number | null,
      idleCount?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListProductsQueryVariables = {
  dummy?: string | null,
};

export type ListProductsQuery = {
  listProducts?:  {
    __typename: "LambdaResp",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type ValidateRoleArnQueryVariables = {
  roleArn?: string | null,
};

export type ValidateRoleArnQuery = {
  validateRoleArn?:  {
    __typename: "LambdaResp",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type GetEc2PriceQueryVariables = {
  instanceType: string,
  region: string,
};

export type GetEc2PriceQuery = {
  getEc2Price?:  {
    __typename: "Ec2Price",
    instanceType: string,
    region: string,
    price: string,
    location?: string | null,
    instanceFamily?: string | null,
    vCPU?: string | null,
    memory?: string | null,
    storage?: string | null,
    networkPerformance?: string | null,
    operatingSystem?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEc2PricesQueryVariables = {
  instanceType?: string | null,
  region?: ModelStringKeyConditionInput | null,
  filter?: ModelEc2PriceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEc2PricesQuery = {
  listEc2Prices?:  {
    __typename: "ModelEc2PriceConnection",
    items:  Array< {
      __typename: "Ec2Price",
      instanceType: string,
      region: string,
      price: string,
      location?: string | null,
      instanceFamily?: string | null,
      vCPU?: string | null,
      memory?: string | null,
      storage?: string | null,
      networkPerformance?: string | null,
      operatingSystem?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserInfoQueryVariables = {
  userId: string,
};

export type GetUserInfoQuery = {
  getUserInfo?:  {
    __typename: "UserInfo",
    userId: string,
    accounts?:  {
      __typename: "ModelAccountInfoConnection",
      items:  Array< {
        __typename: "AccountInfo",
        accountId: string,
        monitorRoleArn: string,
        accountName?: string | null,
        refreshRule?: string | null,
        createdAt: string,
        updatedAt: string,
        userInfoAccountsUserId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userName?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListUserInfosQueryVariables = {
  userId?: string | null,
  filter?: ModelUserInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserInfosQuery = {
  listUserInfos?:  {
    __typename: "ModelUserInfoConnection",
    items:  Array< {
      __typename: "UserInfo",
      userId: string,
      accounts?:  {
        __typename: "ModelAccountInfoConnection",
        nextToken?: string | null,
      } | null,
      userName?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAccountInfoQueryVariables = {
  accountId: string,
};

export type GetAccountInfoQuery = {
  getAccountInfo?:  {
    __typename: "AccountInfo",
    accountId: string,
    monitorRoleArn: string,
    accountName?: string | null,
    refreshRule?: string | null,
    createdAt: string,
    updatedAt: string,
    userInfoAccountsUserId?: string | null,
    owner?: string | null,
  } | null,
};

export type ListAccountInfosQueryVariables = {
  accountId?: string | null,
  filter?: ModelAccountInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAccountInfosQuery = {
  listAccountInfos?:  {
    __typename: "ModelAccountInfoConnection",
    items:  Array< {
      __typename: "AccountInfo",
      accountId: string,
      monitorRoleArn: string,
      accountName?: string | null,
      refreshRule?: string | null,
      createdAt: string,
      updatedAt: string,
      userInfoAccountsUserId?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAccountQuotaQueryVariables = {
  accountId: string,
};

export type GetAccountQuotaQuery = {
  getAccountQuota?:  {
    __typename: "AccountQuota",
    accountId: string,
    scanQuota: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListAccountQuotasQueryVariables = {
  accountId?: string | null,
  filter?: ModelAccountQuotaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAccountQuotasQuery = {
  listAccountQuotas?:  {
    __typename: "ModelAccountQuotaConnection",
    items:  Array< {
      __typename: "AccountQuota",
      accountId: string,
      scanQuota: number,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAccountPaymentsQueryVariables = {
  accountId: string,
  orderId: string,
};

export type GetAccountPaymentsQuery = {
  getAccountPayments?:  {
    __typename: "AccountPayments",
    accountId: string,
    orderId: string,
    productId: string,
    status: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListAccountPaymentsQueryVariables = {
  accountId?: string | null,
  orderId?: ModelStringKeyConditionInput | null,
  filter?: ModelAccountPaymentsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAccountPaymentsQuery = {
  listAccountPayments?:  {
    __typename: "ModelAccountPaymentsConnection",
    items:  Array< {
      __typename: "AccountPayments",
      accountId: string,
      orderId: string,
      productId: string,
      status: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAccountToResourceQueryVariables = {
  accountId: string,
  resourceId: string,
};

export type GetAccountToResourceQuery = {
  getAccountToResource?:  {
    __typename: "AccountToResource",
    accountId: string,
    resourceId: string,
    resourceRegion: string,
    resourceStatus: ResourceStatus,
    resourceType?: string | null,
    resourceCreatedAt?: string | null,
    resourcePriceType?: string | null,
    tags?: string | null,
    index?: number | null,
    summary?:  {
      __typename: "Summary",
      resourceType?: string | null,
      status?: ScanStatus | null,
      scannedCount?: number | null,
      idleCount?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListAccountToResourcesQueryVariables = {
  accountId?: string | null,
  resourceId?: ModelStringKeyConditionInput | null,
  filter?: ModelAccountToResourceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAccountToResourcesQuery = {
  listAccountToResources?:  {
    __typename: "ModelAccountToResourceConnection",
    items:  Array< {
      __typename: "AccountToResource",
      accountId: string,
      resourceId: string,
      resourceRegion: string,
      resourceStatus: ResourceStatus,
      resourceType?: string | null,
      resourceCreatedAt?: string | null,
      resourcePriceType?: string | null,
      tags?: string | null,
      index?: number | null,
      summary?:  {
        __typename: "Summary",
        resourceType?: string | null,
        status?: ScanStatus | null,
        scannedCount?: number | null,
        idleCount?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateEc2PriceSubscriptionVariables = {
  filter?: ModelSubscriptionEc2PriceFilterInput | null,
};

export type OnCreateEc2PriceSubscription = {
  onCreateEc2Price?:  {
    __typename: "Ec2Price",
    instanceType: string,
    region: string,
    price: string,
    location?: string | null,
    instanceFamily?: string | null,
    vCPU?: string | null,
    memory?: string | null,
    storage?: string | null,
    networkPerformance?: string | null,
    operatingSystem?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEc2PriceSubscriptionVariables = {
  filter?: ModelSubscriptionEc2PriceFilterInput | null,
};

export type OnUpdateEc2PriceSubscription = {
  onUpdateEc2Price?:  {
    __typename: "Ec2Price",
    instanceType: string,
    region: string,
    price: string,
    location?: string | null,
    instanceFamily?: string | null,
    vCPU?: string | null,
    memory?: string | null,
    storage?: string | null,
    networkPerformance?: string | null,
    operatingSystem?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEc2PriceSubscriptionVariables = {
  filter?: ModelSubscriptionEc2PriceFilterInput | null,
};

export type OnDeleteEc2PriceSubscription = {
  onDeleteEc2Price?:  {
    __typename: "Ec2Price",
    instanceType: string,
    region: string,
    price: string,
    location?: string | null,
    instanceFamily?: string | null,
    vCPU?: string | null,
    memory?: string | null,
    storage?: string | null,
    networkPerformance?: string | null,
    operatingSystem?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserInfoSubscriptionVariables = {
  filter?: ModelSubscriptionUserInfoFilterInput | null,
  owner?: string | null,
};

export type OnCreateUserInfoSubscription = {
  onCreateUserInfo?:  {
    __typename: "UserInfo",
    userId: string,
    accounts?:  {
      __typename: "ModelAccountInfoConnection",
      items:  Array< {
        __typename: "AccountInfo",
        accountId: string,
        monitorRoleArn: string,
        accountName?: string | null,
        refreshRule?: string | null,
        createdAt: string,
        updatedAt: string,
        userInfoAccountsUserId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userName?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateUserInfoSubscriptionVariables = {
  filter?: ModelSubscriptionUserInfoFilterInput | null,
  owner?: string | null,
};

export type OnUpdateUserInfoSubscription = {
  onUpdateUserInfo?:  {
    __typename: "UserInfo",
    userId: string,
    accounts?:  {
      __typename: "ModelAccountInfoConnection",
      items:  Array< {
        __typename: "AccountInfo",
        accountId: string,
        monitorRoleArn: string,
        accountName?: string | null,
        refreshRule?: string | null,
        createdAt: string,
        updatedAt: string,
        userInfoAccountsUserId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userName?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteUserInfoSubscriptionVariables = {
  filter?: ModelSubscriptionUserInfoFilterInput | null,
  owner?: string | null,
};

export type OnDeleteUserInfoSubscription = {
  onDeleteUserInfo?:  {
    __typename: "UserInfo",
    userId: string,
    accounts?:  {
      __typename: "ModelAccountInfoConnection",
      items:  Array< {
        __typename: "AccountInfo",
        accountId: string,
        monitorRoleArn: string,
        accountName?: string | null,
        refreshRule?: string | null,
        createdAt: string,
        updatedAt: string,
        userInfoAccountsUserId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    userName?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateAccountInfoSubscriptionVariables = {
  filter?: ModelSubscriptionAccountInfoFilterInput | null,
  owner?: string | null,
};

export type OnCreateAccountInfoSubscription = {
  onCreateAccountInfo?:  {
    __typename: "AccountInfo",
    accountId: string,
    monitorRoleArn: string,
    accountName?: string | null,
    refreshRule?: string | null,
    createdAt: string,
    updatedAt: string,
    userInfoAccountsUserId?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdateAccountInfoSubscriptionVariables = {
  filter?: ModelSubscriptionAccountInfoFilterInput | null,
  owner?: string | null,
};

export type OnUpdateAccountInfoSubscription = {
  onUpdateAccountInfo?:  {
    __typename: "AccountInfo",
    accountId: string,
    monitorRoleArn: string,
    accountName?: string | null,
    refreshRule?: string | null,
    createdAt: string,
    updatedAt: string,
    userInfoAccountsUserId?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeleteAccountInfoSubscriptionVariables = {
  filter?: ModelSubscriptionAccountInfoFilterInput | null,
  owner?: string | null,
};

export type OnDeleteAccountInfoSubscription = {
  onDeleteAccountInfo?:  {
    __typename: "AccountInfo",
    accountId: string,
    monitorRoleArn: string,
    accountName?: string | null,
    refreshRule?: string | null,
    createdAt: string,
    updatedAt: string,
    userInfoAccountsUserId?: string | null,
    owner?: string | null,
  } | null,
};

export type OnCreateAccountQuotaSubscriptionVariables = {
  filter?: ModelSubscriptionAccountQuotaFilterInput | null,
  owner?: string | null,
};

export type OnCreateAccountQuotaSubscription = {
  onCreateAccountQuota?:  {
    __typename: "AccountQuota",
    accountId: string,
    scanQuota: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateAccountQuotaSubscriptionVariables = {
  filter?: ModelSubscriptionAccountQuotaFilterInput | null,
  owner?: string | null,
};

export type OnUpdateAccountQuotaSubscription = {
  onUpdateAccountQuota?:  {
    __typename: "AccountQuota",
    accountId: string,
    scanQuota: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteAccountQuotaSubscriptionVariables = {
  filter?: ModelSubscriptionAccountQuotaFilterInput | null,
  owner?: string | null,
};

export type OnDeleteAccountQuotaSubscription = {
  onDeleteAccountQuota?:  {
    __typename: "AccountQuota",
    accountId: string,
    scanQuota: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateAccountPaymentsSubscriptionVariables = {
  filter?: ModelSubscriptionAccountPaymentsFilterInput | null,
  owner?: string | null,
};

export type OnCreateAccountPaymentsSubscription = {
  onCreateAccountPayments?:  {
    __typename: "AccountPayments",
    accountId: string,
    orderId: string,
    productId: string,
    status: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateAccountPaymentsSubscriptionVariables = {
  filter?: ModelSubscriptionAccountPaymentsFilterInput | null,
  owner?: string | null,
};

export type OnUpdateAccountPaymentsSubscription = {
  onUpdateAccountPayments?:  {
    __typename: "AccountPayments",
    accountId: string,
    orderId: string,
    productId: string,
    status: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteAccountPaymentsSubscriptionVariables = {
  filter?: ModelSubscriptionAccountPaymentsFilterInput | null,
  owner?: string | null,
};

export type OnDeleteAccountPaymentsSubscription = {
  onDeleteAccountPayments?:  {
    __typename: "AccountPayments",
    accountId: string,
    orderId: string,
    productId: string,
    status: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateAccountToResourceSubscriptionVariables = {
  filter?: ModelSubscriptionAccountToResourceFilterInput | null,
  owner?: string | null,
};

export type OnCreateAccountToResourceSubscription = {
  onCreateAccountToResource?:  {
    __typename: "AccountToResource",
    accountId: string,
    resourceId: string,
    resourceRegion: string,
    resourceStatus: ResourceStatus,
    resourceType?: string | null,
    resourceCreatedAt?: string | null,
    resourcePriceType?: string | null,
    tags?: string | null,
    index?: number | null,
    summary?:  {
      __typename: "Summary",
      resourceType?: string | null,
      status?: ScanStatus | null,
      scannedCount?: number | null,
      idleCount?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateAccountToResourceSubscriptionVariables = {
  filter?: ModelSubscriptionAccountToResourceFilterInput | null,
  owner?: string | null,
};

export type OnUpdateAccountToResourceSubscription = {
  onUpdateAccountToResource?:  {
    __typename: "AccountToResource",
    accountId: string,
    resourceId: string,
    resourceRegion: string,
    resourceStatus: ResourceStatus,
    resourceType?: string | null,
    resourceCreatedAt?: string | null,
    resourcePriceType?: string | null,
    tags?: string | null,
    index?: number | null,
    summary?:  {
      __typename: "Summary",
      resourceType?: string | null,
      status?: ScanStatus | null,
      scannedCount?: number | null,
      idleCount?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteAccountToResourceSubscriptionVariables = {
  filter?: ModelSubscriptionAccountToResourceFilterInput | null,
  owner?: string | null,
};

export type OnDeleteAccountToResourceSubscription = {
  onDeleteAccountToResource?:  {
    __typename: "AccountToResource",
    accountId: string,
    resourceId: string,
    resourceRegion: string,
    resourceStatus: ResourceStatus,
    resourceType?: string | null,
    resourceCreatedAt?: string | null,
    resourcePriceType?: string | null,
    tags?: string | null,
    index?: number | null,
    summary?:  {
      __typename: "Summary",
      resourceType?: string | null,
      status?: ScanStatus | null,
      scannedCount?: number | null,
      idleCount?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};
